import React, { memo } from 'react'

import type { SelectedCategory } from '../../../../types'
import { getDirectParentFromBreadcrumbs } from '../../../../utils/breadcrumbs'
import * as S from './styled'

type CategoryValueProps = {
  selectedCategory: SelectedCategory | null
  showParent?: boolean
}

export const CategoryValue = memo(({ selectedCategory, showParent = true }: CategoryValueProps) => {
  const directParent = showParent
    ? getDirectParentFromBreadcrumbs(selectedCategory?.breadcrumbs || [])
    : null

  return (
    <S.Value>
      {selectedCategory?.name || ''}
      {directParent && (
        <span>
          {` `}in {directParent}
        </span>
      )}
    </S.Value>
  )
})
